import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.387 42.774 7.018-8.394-7.018-7.11v15.504Zm0-18.672 8.6 8.713c.807.817.86 2.113.124 2.994l-7.018 8.394a2.223 2.223 0 0 1-3.93-1.43v-16.49L7.94 33.218a1.112 1.112 0 1 1-1.655-1.487l6.907-7.697-6.871-6.96a1.111 1.111 0 1 1 1.582-1.565l6.26 6.34V5.226A2.225 2.225 0 0 1 18.004 3.7l7.009 7.436c.794.843.81 2.154.037 3.016l-8.664 9.654v.297Zm7.009-11.439-7.01-7.437v15.247l7.01-7.81Zm12.757 23.884a1.024 1.024 0 0 1-1.449-1.448c6.001-6.001 6.001-15.73 0-21.73a1.024 1.024 0 1 1 1.449-1.45c6.8 6.801 6.8 17.828 0 24.628Zm-4.346-4.346a1.024 1.024 0 0 1-1.449-1.448 9.22 9.22 0 0 0 0-13.039 1.024 1.024 0 0 1 1.449-1.448c4.4 4.4 4.4 11.535 0 15.935Z",
    fill: "currentColor"
  }));
};

var SvgBluetooth = styled(SvgComponent).withConfig({
  displayName: "Bluetooth__SvgBluetooth",
  componentId: "sc-9ar88s-0"
})(["", " ", ""], size, color);
export default SvgBluetooth;